import { createProvideInject } from '@collector/shared-ui'

import { PitchOverlaySupportedStatuses } from '../configuration'

export const [
  providePitchOverlaySupportedStatuses,
  injectPitchOverlaySupportedStatuses,
] = createProvideInject<PitchOverlaySupportedStatuses>(
  'pitchOverlaySupportedStatuses',
)
